import http from './http';

interface IGetMacList {
  pageNum: number;
  pageSize: number;
  useStatus?: 0 | 1 | 2 | null; // 0关机 1使用中 2开机未使用 null或不传返回全部
}

interface IMachineConfig {
  adminPassword?: string;
  autoShutdownMinutes?: number;
  autoStartupFlag?: boolean;
  banMinors?: boolean;
  lockScreenFlag?: boolean;
}

interface IHardwareParams {
  ip: string;
}

interface IOpenorCloseParam extends IHardwareParams {
  flag?: 0 | 1;
}

// 获取门店下机器硬件信息列表
export const getMachineList = (data: IGetMacList) => {
  return http({
    url: '/computers/machine/all',
    method: 'POST',
    data,
  });
};

// 查询门店电脑配置
export const getMachineConfig = () => {
  return http({
    url: `/shops/computers/config`,
    method: 'GET',
  });
};

// 保存门店电脑配置
export const saveMachineConfig = (data: IMachineConfig) => {
  return http({
    url: '/shops/computers/config',
    method: 'POST',
    data,
  });
};

// 硬件信息变更记录查询
export const getHardwareHistory = (data: IHardwareParams) => {
  return http({
    url: '/computers/hardware/info',
    method: 'POST',
    data,
  });
};

// 变更硬件状态
export const updateHardwareStatus = (data: IHardwareParams) => {
  return http({
    url: '/computers/hardware/status',
    method: 'PUT',
    data,
  });
};

// 变更查房检测状态
export const updateHardwareVisualStatus = (data: IHardwareParams) => {
  return http({
    url: '/computers/hardware/visual-status',
    method: 'PUT',
    data,
  });
};

// 开机-关机操作
export const OpenOrCloseOperate = (data: IOpenorCloseParam) => {
  return http({
    url: '/computers/customer/status',
    method: 'PUT',
    data,
  });
};

// 校验机器状态
export const CheckMachineStatus = (data: IOpenorCloseParam) => {
  return http({
    url: '/computers/machine/check-status',
    method: 'POST',
    data,
  });
};

// 查询某机器30天内的使用记录
export const fetchUsageRecordHistory = (data: { no: string }) => {
  return http({
    url: '/computers/machine/usage-record',
    method: 'POST',
    data,
  });
};

// 查询设备基础信息
export const getDeviceBaseInfo = (params: { computerIp: string }) => {
  return http({
    url: '/computers/hardware/query-status',
    method: 'POST',
    params,
  });
};

// yServer 重启命令
export const restartYserver = () => {
  return http({
    url: `/shops/computers/config/send-restart`,
    method: 'GET',
  });
};

// 查询身份证读卡器列表信息
export const fetchIdCardList = (data?) => {
  return http({
    url: `/identity-card-reader/search`,
    method: 'GET',
    params: data,
  });
};

// 启用身份证读卡器
export const fetchIdCardStatus = (data) => {
  return http({
    url: `/identity-card-reader/start`,
    method: 'POST',
    data,
  });
};

// 电脑新硬件详情
export const fetchHardwareSysInfo = ({ ip }: { ip: string }) => {
  return http({
    url: `/computers/hardware/sys-info`,
    method: 'GET',
    params: { ip },
  });
};

// 实时监控开启
export const openRealTimeWatchHardware = (data) => {
  return http({
    url: `/computers/hardware/actual-time/watch/open`,
    method: 'POST',
    data,
  });
};

// 实时监控关闭
export const closeRealTimeWatchHardware = (data) => {
  return http({
    url: `/computers/hardware/actual-time/watch/close`,
    method: 'POST',
    data,
  });
};

// 实时监控轮询
export const queryRealTimeWatchHardware = (data) => {
  return http({
    url: `/computers/hardware/actual-time/watch/query`,
    method: 'POST',
    data,
  });
};

// 顾客登录开关
export const machineBanLogin = (data: { banLogin: boolean; id: number }) => {
  return http({
    url: '/computers/machine/ban-login',
    method: 'PUT',
    data,
  });
};

// 云电脑开关
export const machineCloudComputer = (data: { cloudPcFlag: boolean; id: number }) => {
  return http({
    url: '/computers/machine/update/cloud-pc-flag',
    method: 'PUT',
    data,
  });
};

// 查询电脑使用日志
export const queryComputerEventRecord = (data) => {
  return http({
    url: '/computers/machine/event-record',
    method: 'POST',
    data,
  });
};

// 下载电脑使用日志
export const exportComputerEventRecord = (data) => {
  return http({
    url: '/computers/machine/event-record/file/download',
    method: 'POST',
    responseType: 'blob',
    data,
  });
};

// 查询电脑使用统计
export const queryComputerUsageRecord = (data) => {
  return http({
    url: '/computers/machine/v2/usage-record',
    method: 'POST',
    data,
  });
};

// 下载配置信息
export const downloadHardwareFile = () => {
  return http({
    method: 'GET',
    url: '/computers/hardware/file/download',
    responseType: 'blob',
  });
};

// 更新机器自检异常提醒标记
export const updateAlertFlag = (data: { flag: boolean; ip: string }) => {
  return http({
    url: '/computers/machine/update/alert-flag',
    method: 'PUT',
    data,
  });
};
// 下载电脑使用统计
export const exportComputerUsageRecord = (data) => {
  return http({
    url: '/computers/machine/v2/usage-record/file/download',
    method: 'POST',
    responseType: 'blob',
    data,
  });
};
// 批量更新机器自检异常提醒标记
export const batchUpdateAlertFlag = (data: { flag: boolean }) => {
  return http({
    url: '/computers/machine/update-batch/alert-flag',
    method: 'PUT',
    data,
  });
};
